module.exports = __webpack_public_path__ + "img/light_brown.54a46f72.svg";